import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TopupServiceService } from '../Services/topup-service.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CookieService } from '../Services/cookie';
import { CardServiceService } from '../Services/card-service.service';

@Component({
  selector: 'app-success-payment',
  templateUrl: './success-payment.component.html',
  standalone:false,
  styleUrls: ['./success-payment.component.scss']
})
export class SuccessPaymentComponent implements OnInit {
  flow: string;
  prodType: string;
  Screen: string;
  RefID: string;
  formattedAmount: any;

  constructor(private cookieService: CookieService, private route: ActivatedRoute, public datepipe: DatePipe, public topup: TopupServiceService, private _router: Router, private auth: AuthService, private commonP: CommonService, private topupservice: TopupServiceService, private cardService: CardServiceService) { }
  PaymentID: string = '';
  result: string = ''
  currentDate: Date = new Date();
  time: number = new Date().getTime();
  amount: string;
  Service: string = ''
  RequestLetter: boolean = false
  pendingRequest: boolean = false
  RefId: string = ""
  Email: string = ""
  SelectedinternalId: string = ""
  Servicetype: string = ""
  Referenceid: string = ""
  Product: string = "";


  async ngOnInit(): Promise<any> {

    // this.RefID = await this.cookieService.get("RefranceID", false);
    // this.commonP.presentLoading();
    if(this.auth){
      this.auth.accessToken = await this.commonP.Get("token");

      if (this.auth.detailuser) {
    await  this.auth.VerifyToken({}, this.auth.accessToken).then((data: any) => {

        if (data?.response?.code == 1) {

          // this.UpdatePayment()
          this.commonP.hideLoading();
          console.log("break");
          
        } else {

          this.commonP.hideLoading();
          console.log("break2");
          if (this.flow != 'Quickpay') {
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
  
  
        }
  
  
      })
    } else {
      this.RefID = await this.cookieService.get("RefranceID", false);
   setTimeout(async () => {
      await this.commonP.hideLoading(); // Hide loading after 5 seconds
      console.log("No data then bhaag jao"); // Log after hiding the loading
    }, 5000); // 5000ms = 5 seconds delay
    }
    }
    else {
      this.RefID = await this.cookieService.get("RefranceID", false);
  //  setTimeout(async () => {
  //     // await this.commonP.hideLoading(); // Hide loading after 5 seconds
  //     console.log("No data then bhaag jao"); // Log after hiding the loading
  //   }, 5000); // 5000ms = 5 seconds delay
    }
  


    this.amount =await this.cookieService.get("amount", true);   // decrypted value
    console.log("this.amount", this.amount)



  

  }
  Dashboard() {

    // this.cookieService.deleteAll("/");
    this.cookieService.delete("at");
    this.cookieService.delete("sr");
    if (this.topup.InititePaymentObject) {

      this.topup.clearInititePaymentObject();
      // this.cookieService.remove('at');
      // this.cookieService.remove('sr');
      // this.cookieService.removeAll();
      this._router.navigateByUrl('/DashboardCreditCards');



    } else if (this.topup.ValidatePaymentObject) {

      this.topup.clearValidatePaymentObject();
      // this.cookieService.remove('at');
      // this.cookieService.remove('sr');
      // this.cookieService.removeAll();
      this.commonP.clearLogout();
      this._router.navigateByUrl('/LoginWithIdNum');

    }



  }

  Return() {
    this.cookieService.delete("Refid");
    this.cookieService.delete("RefranceID");
    this.cookieService.delete("email");
    this.cookieService.delete("flow");
    this.cookieService.delete("RefranceID");



    this.cookieService.set("referenceId","",true);
      this._router.navigateByUrl('/LoginWithIdNum');
    

  }
  // Request Letter Once Payment Done For Both RequestLetter Card / Loan
  LettersRequest() {

    let data = {
      internalId: this.SelectedinternalId,
      ServiceType: this.Servicetype,
      Product: this.Product, // C for card, L for loan
    };
    this.cardService.RequestingLetters(data, this.auth.accessToken).then(async (data: any) => {
      if (data?.response?.code == 1) {

        if (data?.response?.content?.card?.referenceNumber !== '') {
          this.RefId = data?.response?.content?.card?.referenceNumber;

        } else if (data?.response?.content?.loan?.referenceNumber !== '') {
          this.RefId = data?.response?.content?.loan?.referenceNumber;

        }
        await this.commonP.hideLoading();


      } else {
        await this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('', '', this._router, data);
      }
    })

  }
  // Update Payment for Request and letter on behave of product and card id
  async UpdatePayment() {

    let body = {
      referenceId: this.Referenceid,
      internalId: this.SelectedinternalId,
      ServiceType: this.Servicetype,
      Product: this.Product, // C for card, L for loan
    };

    this.topupservice.UpdatePaymentService(this.auth.accessToken, body).then((data: any) => {

      if (data?.response?.code == 1) {
        this.Email = data?.response?.content?.email
        this.commonP.hideLoading();
        // this.LettersRequest();
      } else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('', '', this._router, data);

      }

    })


  }


}



